export const meGetAgentName = (agentProductName) => agentProductName.replace(/@.*/, '');
